export default "__VITE_ASSET__BHt$CbHl__"